import { SVGInterface } from "../../interface";

const Hand = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M21.2475 7C21.2475 5.62 20.1275 4.5 18.7475 4.5C18.5775 4.5 18.4075 4.52 18.2475 4.55V4C18.2475 2.62 17.1275 1.5 15.7475 1.5C15.5175 1.5 15.2875 1.53 15.0775 1.59C14.7075 0.66 13.8075 0 12.7475 0C11.5175 0 10.4975 0.89 10.2875 2.06C10.1175 2.02 9.93753 2 9.74753 2C8.36753 2 7.24753 3.12 7.24753 4.5V10.39C6.90753 10.08 6.48753 9.85 6.02753 9.73L5.25753 9.52C4.42753 9.29 3.55753 9.61 3.06753 10.35C2.68753 10.92 2.66753 11.66 2.91753 12.3L5.47753 18.73C6.73753 21.91 9.81753 24 13.2475 24C17.6675 24 21.2475 20.42 21.2475 16V7ZM19.2475 16C19.2475 19.31 16.5575 22 13.2475 22C10.6375 22 8.29753 20.41 7.33753 17.99L4.73753 11.45L5.26753 11.59C5.72753 11.71 6.09753 12.05 6.26753 12.49L7.24753 15H9.24753V4.5C9.24753 4.22 9.46753 4 9.74753 4C10.0275 4 10.2475 4.22 10.2475 4.5V12H12.2475V2.5C12.2475 2.22 12.4675 2 12.7475 2C13.0275 2 13.2475 2.22 13.2475 2.5V12H15.2475V4C15.2475 3.72 15.4675 3.5 15.7475 3.5C16.0275 3.5 16.2475 3.72 16.2475 4V12H18.2475V7C18.2475 6.72 18.4675 6.5 18.7475 6.5C19.0275 6.5 19.2475 6.72 19.2475 7V16Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default Hand;
